// import { request } from '@/service/axios';

import { Languages } from '../../../../hooks';
import { request } from '../../../../service/request';

/**
 * 接口表示中性证书对象
 */
export interface NeutralCert {
  /**
   * 证书 URL
   */
  certUrl: string;
  /**
   * 证书年份
   */
  certYears: string;
}

/**
 * 接口表示用户数据对象
 */
export interface UserData {
  /**
   * 用户 ID
   */
  id: number;
  /**
   * 真实姓名
   */
  realName: string;
  /**
   * 昵称
   */
  nickName: string;
  /**
   * 手机号码
   */
  mobile: string;
  /**
   * 头像 URL
   */
  avatarUrl: string;
  /**
   * 累计排放量
   */
  totalReduction: string;
  /**
   * 累计排放量单位
   */
  totalReductionUnit: string;
  /**
   * 碳信用抵消量
   */
  totalOffsetting: string;
  /**
   * 碳信用抵消量单位
   */
  totalOffsettingUnit: string;
  /**
   * 用户状态码
   */
  userStatus: number;
  /**
   * 用户状态名称
   */
  userStatus_name: string;
  /**
   * 语言
   */
  lang: string;
  /**
   * 中性证书列表
   */
  neutralCertList: NeutralCert[];
}

/**
 * 编辑昵称
 */
export const editNickName = (data: { nickName: string }) => {
  return request<{ code: number; data: string }>({
    method: 'POST',
    url: '/login/editUserInfo',
    data,
  });
};

export const getUserInfo = () => {
  return request<{ code: number; data: UserData }>({
    method: 'GET',
    url: '/user/getCenterUserInfo',
  });
};

/**
 * 退出登录
 */
export const logout = () => {
  return request<{ code: number; data: string }>({
    method: 'GET',
    url: '/login/wx/logout',
  });
};

export const languagesSwitch = (params: { lang: Languages }) =>
  request<{ code: number; data: { lang: Languages }; msg: string }>({
    url: '/user/languageSwitch',
    params,
    method: 'GET',
  });
